import { ValidatorFn } from "@angular/forms";

export const permissiveUrlValidator: ValidatorFn = (control) => {
  const urlRegex = /^(https?:\/\/|http:\/\/|www\.)?[\w-]+(\.[\w-]+)+(:\d+)?(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i;
  const value = control.value;
  if (!value || typeof value !== 'string') return null;
  return urlRegex.test(value.trim()) ? null : { permissiveUrl: true };
};